import { ProtectedRoute, ThemeProvider } from '@invisoutlet/shared/components';
import { AuthProvider } from '@invisoutlet/shared/context';
import { Route, Routes } from 'react-router-dom';
import AlertsPage from './routes/alerts.js';
import BuildingOverviewPage from './routes/building-overview.js';
import FloorViewPage from './routes/floor-view.js';
import LoginPage from './routes/login.js';
import RulesPage from './routes/rules.js';
import SettingsPage from './routes/settings.js';
import StayCalendarPage from './routes/stay-calendar.js';
import TableViewPage from './routes/table-view.js';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected — requires role: 'user' */}
          <Route element={<ProtectedRoute requiredRole="user" />}>
            <Route path="/" element={<BuildingOverviewPage />} />
            <Route path="/buildings/:buildingId" element={<FloorViewPage />} />
            <Route path="/table-view" element={<TableViewPage />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/stay-calendar" element={<StayCalendarPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
